module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-900.dabef5fb917670cb54cea7248b05eb0b.woff2";